export default __webpack_public_path__ + "static/media/Mikesh.1e2a10e5.jpg";